/* eslint-disable import/no-anonymous-default-export */
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import 'swiper/css/autoplay';
import './index.css'
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { secureUrl } from '../../../../utils/sortArray/secureUrl';


function createSlide(patternship) {
  return (
    <SwiperSlide>
        <a  style={{textDecoration:'none'}} target='_blank' href={patternship?.linkPatrocinador} >
        <div className='card-patternship-carousel-slide'>
        <img className='img-from-carousel-patternship' width={70} height={70} src={secureUrl(patternship?.imgPatrocinador)} alt="" />
        <div className='card-text-patternship-slide'>
            <p>{patternship?.name}</p>
            <h3 className='subtitle-slogan'>{patternship?.descripcion}</h3>
            {patternship?.telefono && (<h4 className='subtitle-phone-number'> Tel:{patternship?.telefono}</h4>)}
        </div>
        </div>
        </a>
    </SwiperSlide>
  );
}

function createPlaceholder(selectedTournament){
  return(
    <SwiperSlide>
    <a target='_blank' href={`https://wa.me/524778452415?text=Hola%20TalachaApp%20quiero%20anunciarme%20en%20la%20app%20para%20el%20torneo%20${selectedTournament?.name}`}  style={{textDecoration:'none'}}>
    <div className='talacha-card-placeholder-patternship' >
      <h1>Anunciate aqui</h1>

    </div>
    </a>
    </SwiperSlide>
  )
}


const CarouselPatternShip = () => {
    const allPatternships = useSelector(state => state?.tournaments?.selectedTournament?.patrocinadores)
    const selectedTournament = useSelector(state => state?.tournaments?.selectedTournament)

    const [numerSlides, SetNumberSlides] = useState(0)
    const  carouselRef= useRef()
    const getNumberOfSlides = ()=>{
        const getNumber = carouselRef.current?.offsetWidth / 340
        SetNumberSlides(getNumber.toFixed(1))
    }
    useEffect(()=>{
        if(!carouselRef.current) return
        getNumberOfSlides();

    },[carouselRef])

    useEffect(()=>{
        window.addEventListener('resize', ()=>{
            getNumberOfSlides();
        })

        return ()=> window.removeEventListener('resize', ()=>{})

    },[])
    const renderPatternshipCarousel = ()=>{
      if(allPatternships?.length > 3) return allPatternships?.map(patternship => (createSlide(patternship)))
      if(allPatternships?.length > 0 && allPatternships?.length <= 3) return([1,2,3,4]?.map((placeHolder, index)=>{
        if(index + 1 > allPatternships.length) return createPlaceholder(selectedTournament)
          return createSlide(allPatternships?.[index])
      }))
        return [1,2,3,4]?.map(placeHolder => (createPlaceholder(selectedTournament)))
       
    }
  return (
    <div ref={carouselRef}  className='talachaapp-carousel-patternship' >
        {/* <div><h2>Patrocinadores</h2></div> */}
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      slidesPerView={numerSlides}
      navigation
      autoplay={{ delay: 1500 }}
      pagination={{ clickable: true }}
    >
      {renderPatternshipCarousel() }
    </Swiper>

    </div>

  );
};

export default CarouselPatternShip